module.exports = __webpack_public_path__ + "static/media/chilicorn-logo.e1e14d10.svg";